import React from "react";
import { State } from "@store";
import { useSelector } from "react-redux";
import { SettingsModal } from "./settings-modal";

export const Modals: React.FC = () => {
  const { SETTINGS_MODAL_OPEN } = useSelector((state: State) => state.flags);

  return (
    <React.Fragment>
      <SettingsModal open={SETTINGS_MODAL_OPEN} />
    </React.Fragment>
  );
};
